"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toArray2 = require("babel-runtime/helpers/toArray");

var _toArray3 = _interopRequireDefault(_toArray2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function enqueue(array, item) {
  return [].concat((0, _toConsumableArray3.default)(array), [item]);
}

// eslint-disable-next-line no-unused-vars
function dequeue(array, _item) {
  var _array = (0, _toArray3.default)(array),
      rest = _array.slice(1);

  return rest;
}

function peek(array) {
  return array[0];
}

exports.default = {
  enqueue: enqueue,
  dequeue: dequeue,
  peek: peek
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@redux-offline/redux-offline/lib/defaults/queue.js
// module id = 1164
// module chunks = 0